import { render, staticRenderFns } from "./ObiLogo.vue?vue&type=template&id=54fcc5c0&scoped=true&"
import script from "./ObiLogo.vue?vue&type=script&lang=js&"
export * from "./ObiLogo.vue?vue&type=script&lang=js&"
import style0 from "./ObiLogo.vue?vue&type=style&index=0&id=54fcc5c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fcc5c0",
  null
  
)

export default component.exports